import {useMemo} from 'react';

// material-ui
import {useTheme} from '@mui/material/styles';
import {Box, Drawer, useMediaQuery} from '@mui/material';

// project import
import DrawerHeader from './drawerHeader';
import DrawerContent from './drawerContent';
import MiniDrawerStyled from './miniDrawerStyled';
import {DRAWER_WIDTH} from "../../../config";
import useMenuData from "../../../../../hooks/menu/useMenuData";
import useMenuAction from "../../../../../hooks/menu/useMenuAction";

// ==============================|| MAIN LAYOUT - DRAWER ||============================== //

const MainDrawer = ({window}) => {
    const theme = useTheme();
    const matchDownMD = useMediaQuery(theme.breakpoints.down('lg'));
    // responsive drawer container
    const container = window !== undefined ? () => window().document.body : undefined;
    const {drawerOpen} = useMenuData()
    const {setDrawerOpen} = useMenuAction()

    const drawerContent = useMemo(() => <DrawerContent/>, []);
    const drawerHeader = useMemo(() => <DrawerHeader drawerOpen={drawerOpen}/>, [drawerOpen]);

    return (
        <Box component="nav" sx={{flexShrink: {md: 0}, zIndex: 1200}} aria-label="mailbox folders">
            {!matchDownMD ? (
                <MiniDrawerStyled variant="permanent" open={drawerOpen}>
                    {drawerHeader}
                    {drawerContent}
                </MiniDrawerStyled>
            ) : (
                <Drawer
                    container={container}
                    variant="temporary"
                    open={drawerOpen}
                    onClose={() => setDrawerOpen(!drawerOpen)}
                    ModalProps={{keepMounted: true}}
                    sx={{
                        display: {xs: 'block', lg: 'none'},
                        '& .MuiDrawer-paper': {
                            boxSizing: 'border-box',
                            width: DRAWER_WIDTH,
                            borderRight: `1px solid ${theme.palette.divider}`,
                            backgroundImage: 'none',
                            boxShadow: 'inherit'
                        }
                    }}
                >
                    {drawerHeader}
                    {drawerContent}
                </Drawer>
            )}
        </Box>
    );
};

export default MainDrawer;
